module.exports = __webpack_public_path__ + "img/logo_nauka_0.285bf9a9.png";